const endpoint = "congestionregions";

const predendpoint = "/predCongestionData?";

const getQuery = (value) => {
    if(value === 0) return null;
    return predendpoint + new URLSearchParams({
        hours: value,
        ts: new Date().getTime()
    });
}

export default {
    name: 'Regional Congestion',
    label: 'Regional Congestion',
    showOnMap: true, //show on map layer filter
    mapLayerIcon: "",
    showOnSidebar: false,
    endpoint: endpoint,
    defaultOn: false,
    updateDelay: 0,
    publishLayer: "tasWebapp.congestionregions.enable",
    getQuery: getQuery
}